import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Minimize = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="minimize icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M9.00662 13.9999C9.55501 13.9999 9.99978 14.4447 9.99978 14.9931V20.539C9.99978 21.4236 8.92999 21.8666 8.30447 21.2411L6.93631 19.872L4.51541 22.2929C4.12493 22.6833 3.49187 22.6832 3.10135 22.2929L1.70682 20.8984C1.31643 20.5078 1.31636 19.8748 1.70682 19.4843L4.12771 17.0634L2.75857 15.6952C2.13306 15.0697 2.57611 13.9999 3.46072 13.9999H9.00662ZM20.5388 13.9999C21.4235 13.9999 21.8665 15.0697 21.241 15.6952L19.8719 17.0634L22.2928 19.4843C22.6832 19.8748 22.6832 20.5078 22.2928 20.8984L20.8982 22.2929C20.5077 22.6832 19.8746 22.6833 19.4842 22.2929L17.0642 19.872L15.6951 21.2411C15.0696 21.8666 13.9998 21.4236 13.9998 20.539V14.9931C13.9998 14.4447 14.4446 13.9999 14.9929 13.9999H20.5388ZM3.10135 1.70695C3.49187 1.31652 4.12492 1.31647 4.51541 1.70695L6.93631 4.12784L8.30447 2.7587C8.92999 2.13318 9.99978 2.57623 9.99978 3.46085V9.00675C9.99978 9.55514 9.55501 9.99991 9.00662 9.99991H3.46072C2.57611 9.99991 2.13306 8.93012 2.75857 8.3046L4.12771 6.93546L1.70682 4.51554C1.31637 4.12508 1.31648 3.49201 1.70682 3.10148L3.10135 1.70695ZM19.4842 1.70695C19.8746 1.31647 20.5077 1.31657 20.8982 1.70695L22.2928 3.10148C22.6831 3.49201 22.6832 4.12506 22.2928 4.51554L19.8719 6.93546L21.241 8.3046C21.8665 8.93012 21.4235 9.99991 20.5388 9.99991H14.9929C14.4446 9.99991 13.9998 9.55514 13.9998 9.00675V3.46085C13.9998 2.57623 15.0696 2.13318 15.6951 2.7587L17.0642 4.12784L19.4842 1.70695Z"
    />
  </svg>
)
